import styled from 'styled-components';

export default styled.p`
    font-size: 1.6rem;
    font-weight: 600;
    text-align: center;
    margin: 24px;
`;


// WEBPACK FOOTER //
// ./src/SharedComponents/EndText.tsx